import axios from "axios";

export function availableCities(cp) {
    const token = 'TgC1n73rN37Gr0u9';
    const api = `https://contacta-abogado.appspot.com/postal_code/${cp}`;
    return axios.get(api, { headers: {"Authorization" : `Bearer ${token}`} })
            .then(res => res.data )
            .catch(err => {
                return err;
            });
            
 }

 export function getSuburbsByCp(cp) {
    const token = 'TgC1n73rN37Gr0u9';
    const api = `https://contacta-abogado.appspot.com/postal_code/suburbs/${cp}`;
    return axios.get(api, { headers: {"Authorization" : `Bearer ${token}`} })
            .then(res => res.data )
            .catch(err => {
                return false;
            });
            
 }

 export async function states() {
    const token = 'TgC1n73rN37Gr0u9';
    const api = `https://contacta-abogado.appspot.com/postal_code/states`;
    return await axios.get(api, { headers: {"Authorization" : `Bearer ${token}`} })
 }

 export async function cities(states){
    const token = 'TgC1n73rN37Gr0u9';
    const api = `https://contacta-abogado.appspot.com/postal_code/municipality?code=${states}`
    return await axios.get(api, { headers: {"Authorization" : `Bearer ${token}`} });
    
 }




 export function availablePeople(num) {
    const api = `https://rickandmortyapi.com/api/character/`;
    return axios.get(api)
            .then(res => res.data )
            .catch(err => {
                
                return err;
            });
            
 }